module.exports = __webpack_public_path__ + "static/img/gallery5.9ebeb318.png";